import React, { useMemo } from "react";
import DOMPurify from "dompurify";
import "./RichTextEditor.css";

/** Renders stored rich-text HTML safely (sanitized with DOMPurify). */
const RichTextView = ({ html, emptyText = "—" }) => {
    const clean = useMemo(() => {
        if (!html) return "";
        return DOMPurify.sanitize(html, {
            ALLOWED_TAGS: [
                "p", "br", "strong", "b", "em", "i", "s", "u",
                "h2", "h3", "h4", "ul", "ol", "li", "blockquote", "a", "code", "pre",
            ],
            ALLOWED_ATTR: ["href", "target", "rel"],
        });
    }, [html]);

    if (!clean || clean === "<p></p>") {
        return <p className="rte-view__empty">{emptyText}</p>;
    }

    // Legacy records stored plain text — preserve their line breaks
    if (html && !html.includes("<")) {
        return <div className="rte-view rte-view--plain">{html}</div>;
    }

    return (
        <div
            className="rte-view"
            dangerouslySetInnerHTML={{ __html: clean }}
        />
    );
};

export default RichTextView;
